module.exports = __webpack_public_path__ + "static/media/lp_icon_list.42c34e12.svg";